import { render, staticRenderFns } from "./SearchFilterTokens.vue?vue&type=template&id=0c5c3dbf&scoped=true&"
import script from "./SearchFilterTokens.vue?vue&type=script&lang=js&"
export * from "./SearchFilterTokens.vue?vue&type=script&lang=js&"
import style0 from "./SearchFilterTokens.vue?vue&type=style&index=0&id=0c5c3dbf&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c5c3dbf",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0c5c3dbf')) {
      api.createRecord('0c5c3dbf', component.options)
    } else {
      api.reload('0c5c3dbf', component.options)
    }
    module.hot.accept("./SearchFilterTokens.vue?vue&type=template&id=0c5c3dbf&scoped=true&", function () {
      api.rerender('0c5c3dbf', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2kcVIQZ1h51P7/JS/comp/SearchFilterTokens.vue"
export default component.exports